import type { Api } from './client'
import { httpApi } from './client'
import { mockApi } from './mock'

/**
 * Set VITE_USE_MOCK=false once the API from STE-540 is deployed. Nothing else in
 * the app changes: both implementations satisfy the same interface.
 */
const useMock = import.meta.env.VITE_USE_MOCK !== 'false'

export const api: Api = useMock ? mockApi : httpApi
export const isMock = useMock
export type { Api }

/**
 * Sees an import through to the end, however many requests that takes.
 *
 * One commit imports what it can in twenty seconds and saves where it got to,
 * because 5,000 rows need about two minutes and the request is capped at
 * thirty seconds. Before this the function was simply killed part way and the
 * screen showed "Internal Server Error" over a library that had quietly gained
 * twelve hundred roles.
 */
export async function commitAll(
  id: string,
  onProgress?: (imported: number, total: number) => void,
): Promise<number> {
  let imported = 0
  for (let call = 0; call < 400; call++) {
    const step = await api.commitUpload(id)
    imported += step.imported
    if (step.total) onProgress?.(step.position ?? imported, step.total)
    if (step.done !== false) return imported
  }
  throw new Error('That import is taking more calls than expected. Some rows may not have imported.')
}

